export const DUKANTI_MARK_SRC = '/brand/dukanti-mark-64.png';

export interface DukantiBrandMarkProps {
  readonly src?: string;
  readonly className?: string;
  readonly imageClassName?: string;
  readonly alt?: string;
  readonly decorative?: boolean;
}

export function DukantiBrandMark({
  src = DUKANTI_MARK_SRC,
  className = 'size-8',
  imageClassName = 'size-full',
  alt = 'Dukanti',
  decorative = true,
}: DukantiBrandMarkProps) {
  return (
    <span
      className={[
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-md bg-lime-300',
        className,
      ].join(' ')}
    >
      <img
        src={src}
        alt={decorative ? '' : alt}
        aria-hidden={decorative ? 'true' : undefined}
        className={['block object-cover', imageClassName].join(' ')}
        loading="eager"
        decoding="async"
      />
    </span>
  );
}
